import {
  BitkitBadge,
  type BitkitBadgeProps,
  IconCheckCircle,
  IconCrossCircleFilled,
  IconErrorCircleFilled,
  IconSkipCircle,
} from '@bitrise/bitkit-v2';

import { TestStatus } from '../../TestResults.types';

const BADGE_PROPS_MAP: Record<TestStatus, Pick<BitkitBadgeProps, 'colorVariant' | 'icon'>> = {
  passed: { colorVariant: 'green', icon: IconCheckCircle },
  failed: { colorVariant: 'red', icon: IconCrossCircleFilled },
  skipped: { colorVariant: 'neutral', icon: IconSkipCircle },
  error: { colorVariant: 'red', icon: IconErrorCircleFilled },
};

const StatusBadge = ({ status }: { status: TestStatus }) => {
  return <BitkitBadge {...BADGE_PROPS_MAP[status]}>{status}</BitkitBadge>;
};

export default StatusBadge;
